/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Notification API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Notification details
 */
export interface NotificationDTO { 
    /**
     * Notification ID
     */
    id?: string;
    /**
     * Notification subject
     */
    subject?: { [key: string]: string; };
    /**
     * Tenant ID
     */
    tenantId?: string;
    /**
     * Tenant ID
     */
    organizationId?: string;
    /**
     * Tenant ID
     */
    businessPremisesId?: string;
    /**
     * Notification readable from date time
     */
    notificationDate?: string;
    /**
     * Id of user who read notification
     */
    readBy?: string;
    /**
     * Date time when notification was read
     */
    readDate?: string;
    /**
     * Id of user who confirmed notification
     */
    confirmedBy?: string;
    /**
     * Date time when notification was confirmed
     */
    confirmedDate?: string;
    /**
     * Notification message
     */
    message?: { [key: string]: string; };
}

export class ClsNotificationDTO { 
    /**
     * Notification ID
     */
    id?: string = undefined;
    /**
     * Notification subject
     */
    subject?: { [key: string]: string; } = undefined;
    /**
     * Tenant ID
     */
    tenantId?: string = undefined;
    /**
     * Tenant ID
     */
    organizationId?: string = undefined;
    /**
     * Tenant ID
     */
    businessPremisesId?: string = undefined;
    /**
     * Notification readable from date time
     */
    notificationDate?: string = undefined;
    /**
     * Id of user who read notification
     */
    readBy?: string = undefined;
    /**
     * Date time when notification was read
     */
    readDate?: string = undefined;
    /**
     * Id of user who confirmed notification
     */
    confirmedBy?: string = undefined;
    /**
     * Date time when notification was confirmed
     */
    confirmedDate?: string = undefined;
    /**
     * Notification message
     */
    message?: { [key: string]: string; } = undefined;
}

